import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";


import PersonalDetailsTab from "./PersonalDetailsTab";
import MedicalInfoTab from "./MedicalInfoTab";
import OtherMedicalInfoTab from "./OtherMedicalInfoTab";
import TreatmentTargetsTab from "./TreatmentTargetsTab";
import CannabisPatientTab from "./CannabisPatientTab";
import HealthMeasuresTab from "./HealthMeasuresTab";
import ReferralReasonTab from "./ReferralReasonTab";
import DeclarationsTab from "./DeclarationsTab";
import VisitSummaryTab from "./VisitSummaryTab";
import {history} from "../../../utils/history";
import AlertConfirm from "../../../components/modals/Confirm";
import utils from "../../../utils/utils";
import {makeError} from "../../../components/modals/ErrorModal";
import doctorApi from "../../../services/ApiServices/doctorApi";
import HCPsTabTools from "../../../components/hcp/HCPsTabTools";


class TabsDashboardComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: this.props.currentView,
            errors: this.props.errors,
            errorOnSave: this.props.errorOnSave,
            backButtonClicked: false,
            nextButtonClicked: false,
            titrationPlan: this.props.titrationPlan,
            entry: this.props.entry
        };
    }


    componentDidMount() {
        let input = document.getElementById("patientTabs1");

        input?.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("patientTabs1").click();
            }
        });
        input = document.getElementById("patientTabs2");
        input?.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("patientTabs2").click();
            }
        });
        input = document.getElementById("patientTabs3");
        input?.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("patientTabs3").click();
            }
        });
        input = document.getElementById("patientTabs4");
        input?.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("patientTabs4").click();
            }
        });
        input = document.getElementById("patientTabs5");
        input?.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("patientTabs5").click();
            }
        });  input = document.getElementById("patientTabs6");
        input?.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("patientTabs6").click();
            }
        });
        input = document.getElementById("patientTabs7");
        input?.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("patientTabs7").click();
            }
        });
    }

    nextButton = async () => {

        let viewNum = this.props.currentView
        if (viewNum !== 8) {
            viewNum = viewNum + 1;
            this.props.setCurrentView(viewNum)

            // this.setState({view: viewNum});
        }
        this.props.saveAllPatientData("")
        let elmntToView = document.getElementById('patientTabsMainBox');
        if (elmntToView)
            elmntToView.scrollIntoView();
    }

    backButton = () => {
        let viewNum = this.props.currentView
        if (viewNum !== 1) {
            viewNum = viewNum - 1;
            this.props.setCurrentView(viewNum)
        }
        this.props.saveAllPatientData("")
        let elmntToView = document.getElementById('patientTabsMainBox');
        if (elmntToView)
            elmntToView.scrollIntoView();
    }


    changeView = async (i) => {
        let {errorOnSave} = this.state
        let response = await this.props.saveAllPatientData("")
        let errorsget = await this.props.motherClass.getErrors()

        if(response){
            this.props.setCurrentView(i)
        }


    }

    onValueChange = (name, value) => {
        this.props.onValueChange(name, value)
    }
    onClickCheckboxes = (name) => {
        this.props.onClickCheckboxes(name)
    }

    onClickTargetSymptom = (SymptomsInput, name, id) => {
        this.props.onClickTargetSymptom(SymptomsInput, name, id)
    }

    onClickAddProducts = (func, value, index) => {
        this.props.onClickAddProducts(func, value, index)
    }
    editTreatmentPlan = (func, value, index) => {
        this.props.editTreatmentPlan(func, value, index)
    }
    onClickAddDeleteMedications = (index, event, id, type) => {
        this.props.onClickAddDeleteMedications(index, event, id, type)
    }
    onClickPatientAllergics = (event) => {
        this.props.onClickPatientAllergics(event)
    }
    addDeleteTargetSymptom = (name) => {
        this.props.addDeleteTargetSymptom(name)
    }
    addDeleteMedication = (func, index) => {
        this.props.addDeleteMedication(func, index)
    }
    getTitrationPlan = (val, index) => {
        this.props.getTitrationPlan(val, index)
    }
    onClickMedicationConditions = (val) => {
        this.props.onClickMedicationConditions(val)
    }
    onclickSetIsOtherMedicalDiagnosis = () => {
        this.props.onclickSetIsOtherMedicalDiagnosis()
    }
    addTreatmentPlan = () => {
        this.props.addTreatmentPlan()
    }
    getRecommendedTreatment = () => {
        this.props.getRecommendedTreatment()
    }

    getNewTitration = (initialDose, maxDosage, stepEach) => {
        this.props.getNewTitration(initialDose, maxDosage, stepEach)
    }

    addFileObj = (index, selectedCategory, selectedFile) => {
        this.props.addFileObj(index, selectedCategory, selectedFile)
    }
    deleteUploadedFile = (index) => {
        this.props.deleteUploadedFile(index)
    }
    DeleteTreatment = (index) => {
        this.props.DeleteTreatment(index)
    }
    getSymptomsDesc = (Symptom_ID, lang) => {
        return this.props.getSymptomsDesc(Symptom_ID, lang)
    }
    getConditionDesc = (conditionID, lang) => {
        return this.props.getConditionDesc(conditionID, lang)
    }
    getAllergicDesc = (index, lang) => {
        return this.props.getAllergicDesc(index, lang)
    }
    initValidation = (schema) => {
        this.props.initValidation(schema)
    }

    onclickSetProfilePic = (value) => {
        this.props.onclickSetProfilePic(value)
    }
    onChangeNextVisitDocChange = (option) => {
        this.props.onChangeNextVisitDocChange(option)
    }

    async backToDashboard() {
        let confirm = await AlertConfirm({
            options: {
                title: `Back to Patient Page`,
            }
        }, `Are you sure you want to go back to Patient Page, please note that all the data will be deleted?`)
        if (confirm) {

            history.push({
                pathname: `/dashboard`,
                state: {
                    from: {
                        fromPath: `/dashboard/PatientOnboard`,
                    }
                },
            })
        }
    }

    async goBack() {
        history.push({
            pathname: `/dashboard`,
            state: {
                from: {
                    fromPath: `/dashboard/PatientOnboard`,
                }
            },
        })
    }


    render() {
        let {entry} = this.state
        let {t, editMode} = this.props
        let view = this.props.currentView

        return (
            <>
                <div className={'patientTabsMainBox'}  id={'patientTabsMainBox'}>
                    <div tabIndex={0} id={'patientTabs1'} className={view === 1 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                         onClick={() => this.changeView(1)}>
                        <label
                            className={view === 1 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.personal_details')}</label>
                    </div>
                    {editMode && <div tabIndex={0} id={'patientTabs2'} className={view === 2 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                      onClick={() => this.changeView(2)}>
                        <label
                            className={view === 2 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.ReferralReason')}</label>
                    </div>}
                    {editMode && <div tabIndex={0} id={'patientTabs3'} className={view === 3 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                      onClick={() => this.changeView(3)}>
                        <label
                            className={view === 3 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.Medical_information')}</label>
                    </div>}
                    {editMode && <div tabIndex={0} id={'patientTabs4'} className={view === 4 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                      onClick={() => this.changeView(4)}>
                        <label
                            className={view === 4 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.health_measures')}</label>
                    </div>}
                    {editMode && <div tabIndex={0} id={'patientTabs5'} className={view === 5 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                      onClick={() => this.changeView(5)}>
                        <label
                            className={view === 5 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.cannabis_patient_use')}</label>
                    </div>}
                    {editMode && <div tabIndex={0} id={'patientTabs6'} className={view === 6 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                      onClick={() => this.changeView(6)}>
                        <label
                            className={view === 6 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.visit_summury')}</label>
                    </div>}

                    {editMode && <div tabIndex={0} id={'patientTabs7'} className={view === 7 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                      onClick={() => this.changeView(7)}>
                        <label
                            className={view === 7 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.declarations')}</label>
                    </div>}
                    {editMode && <div tabIndex={0} id={'patientTabs8'} className={view === 8 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                      onClick={() => this.changeView(8)}>
                        <label
                            className={view === 8 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_boarding.treatment_plan')}</label>
                    </div>}

                </div>
                {
                    view === 1 ? (<PersonalDetailsTab onValueChange={(name, value) => this.onValueChange(name, value)}
                                                      initValidation={(schema) => this.initValidation(schema)}
                                                      onYesNoValueChange={(name, value) => this.props.onYesNoValueChange(name, value)}
                                                      entry={this.props.entry}
                                                      onclickSetProfilePic={(value) => this.onclickSetProfilePic(value)}
                                                      profilePic={this.props.profilePic}
                                                      allHCPs={this.props.allHCPs}
                                                      errors={this.props.errors}
                                                      israelCities={this.props.israelCities}
                                                      t={e => this.props.t(e)}
                        />)
                        : view === 2 ? (
                            <ReferralReasonTab onValueChange={(name, value) => this.onValueChange(name, value)}
                                               onClickCheckboxes={(name) => this.onClickCheckboxes(name)}
                                               initValidation={(schema) => this.initValidation(schema)}
                                               onYesNoValueChange={(name, value) => this.props.onYesNoValueChange(name, value)}
                                               entry={this.props.entry}
                                               onClickAddProducts={(func, value, index) => this.onClickAddProducts(func, value, index)}
                                               addedProducts={this.props.addedProducts}
                                               checkboxes={this.props.checkboxes}
                                               errors={this.props.errors}
                                               productsList={this.props.productsList}
                                               t={e => this.props.t(e)}
                                               symptoms={this.props.symptoms}
                                               symptomsList={this.props.symptomsList}
                                               isUploadingFiles={this.props.isUploadingFiles}
                                               addFileObj={(index, selectedCategory, selectedFile) => this.addFileObj(index, selectedCategory, selectedFile)}
                                               deleteUploadedFile={(index) => this.deleteUploadedFile(index)}
                                               addedFilesList={this.props.addedFilesList}
                                               fileForms={this.props.fileForms}
                                               addDeleteTargetSymptom={(name) => this.addDeleteTargetSymptom(name)}
                                               onClickTargetSymptom={(SymptomsInput, name, id) => this.onClickTargetSymptom(SymptomsInput, name, id)}
                            />)
                        : view === 3 ? (<MedicalInfoTab onValueChange={(name, value) => this.onValueChange(name, value)}
                                                        entry={this.props.entry}
                                                        initValidation={(schema) => this.initValidation(schema)}
                                                        onYesNoValueChange={(name, value) => this.props.onYesNoValueChange(name, value)}
                                                        deleteUploadedFile={(index) => this.deleteUploadedFile(index)}
                                                        psychiatric_diagnose_icd={this.props.psychiatric_diagnose_icd}
                                                        errors={this.props.errors}
                                                        medicalConditionsSelected={this.props.medicalConditionsSelected}
                                                        onClickMedicationConditions={(conditions) => this.onClickMedicationConditions(conditions)}
                                                        medications_conditions={this.state.medications_conditions}
                                                        medicalConditions={this.props.medicalConditions}
                                                        t={e => this.props.t(e)}
                                                        allergics={this.props.allergics}
                                                        onClickAddDeleteMedications={(index, event, id, type) => this.onClickAddDeleteMedications(index, event, id, type)}
                                                        onClickPatientAllergics={(value) => this.onClickPatientAllergics(value)}
                                                        addDeleteMedication={(func, index) => this.addDeleteMedication(func, index)}
                                                        general_medications={this.props.general_medications}
                                                        bloodThinner_medications={this.props.bloodThinner_medications}
                                                        currentPain_medications={this.props.currentPain_medications}
                                                        past_med={this.props.past_med}
                                                        patient_allergics={this.props.patient_allergics}
                                                        isOtherPastUseMedication={this.props.isOtherPastUseMedication}
                                                        medicationsList={this.props.medicationsList}
                            />)


                            : view === 4 ? (
                                    <HealthMeasuresTab onValueChange={(name, value) => this.onValueChange(name, value)}
                                                       entry={this.props.entry}
                                                       t={e => this.props.t(e)}
                                                       errors={this.props.errors}/>)

                                : view === 5 ? (<CannabisPatientTab
                                        onValueChange={(name, value) => this.onValueChange(name, value)}
                                        onClickCheckboxes={(name) => this.onClickCheckboxes(name)}
                                        initValidation={(schema) => this.initValidation(schema)}
                                        onYesNoValueChange={(name, value) => this.props.onYesNoValueChange(name, value)}
                                        entry={this.props.entry}
                                        onClickAddProducts={(func, value, index) => this.onClickAddProducts(func, value, index)}
                                        addedProducts={this.props.addedProducts}
                                        checkboxes={this.props.checkboxes}
                                        errors={this.props.errors}
                                        productsList={this.props.productsList}
                                        t={e => this.props.t(e)}
                                    />)
                                    : view === 6 ? (<VisitSummaryTab
                                            onValueChange={(name, value) => this.onValueChange(name, value)}
                                            saveAllPatientData={(value) => this.props.saveAllPatientData(value)}
                                            entry={this.props.entry}
                                            t={e => this.props.t(e)}
                                            onclickSetIsOtherMedicalDiagnosis={() => this.onclickSetIsOtherMedicalDiagnosis()}
                                            errors={this.props.errors}
                                            patientTreatments={this.props.patientTreatments}
                                            medical_diagnose_icd={this.props.medical_diagnose_icd}
                                            symptoms={this.props.symptoms}
                                            onClickCheckboxes={(name) => this.onClickCheckboxes(name)}
                                            onChangeNextVisitDocChange={(option) => this.onChangeNextVisitDocChange(option)}
                                            onYesNoValueChange={(name, value) => this.props.onYesNoValueChange(name, value)}
                                            isOtherPsychiatricDiagnosis={this.props.isOtherPsychiatricDiagnosis}
                                            medicationsList={this.props.medicationsList}
                                            nextVisitDoc={this.props.nextVisitDoc}
                                            motherClass={this.props.motherClass}
                                            getAllergicDesc={(index, lang) => this.getAllergicDesc(index, lang)}
                                            getConditionDesc={(conditionID, lang) => this.getConditionDesc(conditionID, lang)}
                                            getSymptomsDesc={(Symptom_ID, lang) => this.getSymptomsDesc(Symptom_ID, lang)}
                                            initValidation={(schema) => this.initValidation(schema)}
                                            checkboxes={this.props.checkboxes}
                                            general_medications={this.props.general_medications}
                                            bloodThinner_medications={this.props.bloodThinner_medications}
                                            currentPain_medications={this.props.currentPain_medications}
                                            medicalConditionsSelected={this.props.medicalConditionsSelected}
                                            nextVisitDocSelected={this.props.nextVisitDocSelected}
                                            past_med={this.props.past_med}
                                            patient_allergics={this.props.patient_allergics}
                                        />): view === 7 ? (<DeclarationsTab
                                            onValueChange={(name, value) => this.onValueChange(name, value)}
                                            onClickCheckboxes={(name) => this.onClickCheckboxes(name)}
                                            entry={this.props.entry}
                                            errors={this.props.errors}
                                            t={e => this.props.t(e)}

                                        />)
                                        : view === 8? (<TreatmentTargetsTab
                                                    onValueChange={(name, value) => this.onValueChange(name, value)}
                                                    entry={this.props.entry}
                                                    errors={this.props.errors}
                                                    titrationPlans={this.props.titrationPlans}
                                                    symptomsList={this.props.symptomsList}
                                                    choosenTargetsSymptoms={this.props.choosenTargetsSymptoms}
                                                    patientTreatments={this.props.patientTreatments}
                                                    symptoms={this.props.symptoms}
                                                    getSymptomsDesc={(Symptom_ID, lang) => this.getSymptomsDesc(Symptom_ID, lang)}
                                                    t={e => this.props.t(e)}
                                                    titrationPlan={this.props.titrationPlan}
                                                    getNewTitration={(initialDose, maxDosage, stepEach) => this.getNewTitration(initialDose, maxDosage, stepEach)}
                                                    getTitrationPlan={(val, index) => this.getTitrationPlan(val, index)}
                                                    DeleteTreatment={(index) => this.DeleteTreatment(index)}
                                                    getRecommendedTreatment={() => this.getRecommendedTreatment()}
                                                    addTreatmentPlan={() => this.addTreatmentPlan()}
                                                    editTreatmentPlan={(func, value, index) => this.editTreatmentPlan(func, value, index)}
                                                    productsList={this.props.productsList}

                                                />)
                                            : <div/>
                }
                <div className={'blankSpace'}/>

                <div className={'backBox'}>
                    <div className={'backBoxRighting'} onClick={this.backButton.bind(this)}
                         style={{display: view !== 1 ? 'block' : 'none'}}>
                        {t('patient_boarding.back')}
                    </div>
                    <div className={'saveBoxRighting'} onClick={() => this.props.saveAllPatientData("save")}
                         style={{display: (editMode) ? 'block' : 'none'}}>
                        {t('patient_boarding.save')}
                    </div>
                    <div className={'nextBoxRighting'} onClick={this.nextButton.bind(this)}
                         style={{display: (editMode && view !== 8) ? 'block' : 'none'}}>
                        {t('patient_boarding.next')}
                    </div>
                    <div className={'nextBoxRighting2'} onClick={() => this.props.savePatient()}
                         style={{display: !editMode ? 'block' : 'none'}}>
                        {t('patient_boarding.save')}
                    </div>
                </div>
                <div className={'add-patient-bottom-page'}>
                </div>
            </>
        );
    }
}


const TabsDashboard = compose(
    withTranslation(),
)(TabsDashboardComposed);

export default TabsDashboard;
